import {h, Component} from 'preact'
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import constants from '../constants'

import Renderer from '../canvas/renderer'

import PositionTools from './PositionTools'
import MenuObjectBorderWidget from "./MenuObjectBorderWidget";
import MenuObject from '../canvas/menu-object';
import store from "../store";
import util from '../util';
import ResizeTextWidget from "./ResizeTextWidget";
import GroupBarListItem from "./GroupBarListItem";
import HyperlinkWidget from './HyperlinkWidget';
import {canDisplayAlign} from "../canvas/component";
import { UnlockOutlined, LockOutlined, DeleteOutlined } from "@ant-design/icons";
import MONameBorderWidget from './MONameBorderWidget';
import MONotesBorderWidget from './MONotesBorderWidget';

export default @connect(reduce, actions)
class MenuObjectBar extends Component {
  constructor() {
    super();

    this.toggleLock = () => {
      const $elements = this.props.isMultiSelect ? this.props.$elements : this.props.$element;
      if (this.props.isLocked) {
        Renderer.unlock($elements);
      } else {
        Renderer.lock($elements);
      }
      this.props.updateElementAttribute('isLocked', !this.props.isLocked);
    }

    this.openColorPicker = (type) => {
      util.openColorPicker(type);
    }
  }

  remove() {
    const callback = () => {
      store.dispatch(actions.setSelectionType('text'));
      store.dispatch(actions.showLayoutGuideBar(false));
      Renderer.remove(this.props.isMultiSelect ? this.props.$elements : this.props.$element, this.props.isMultiSelect);
      store.dispatch(actions.deselect());
    };
    if (this.props.isMobileVersion) {
      window.ConfirmationModal.show({
        title: 'Are you sure?',
        body: 'This group will be removed and all its data will be lost.',
        acceptLabel: 'Delete',
        declineLabel: 'Cancel',
        onAccept: () => {
          callback();
        },
        onDecline: () => {
          // @ts-ignore
          window.ConfirmationModal.hide()
        }
      });
    } else {
      callback();
    }

  }

  removeGroup() {
    Renderer.remove(this.props.$element.parents('.group'));
    store.dispatch(actions.goToView('text'));
    store.dispatch(actions.setSelectionType('text'));
    store.dispatch(actions.showLayoutGuideBar(false));
    store.dispatch(actions.deselect());
  }

  copy() {
    const $element = this.props.$element;
    store.dispatch(actions.setIsMenuObjectCopied(true));
    if (this.props.isMultiSelect) {
      Renderer.copy(this.props.$elements);
    } else {
      const $group = $element.parents('.group');
      Renderer.copy($group.length > 0 ? $group : $element);
    }
  }

  updateBorderWidth(ev) {
    const val = ev.target.value;
    const width = val / 10 + 'em';
    const color = this.props.borderColor;

    const patch = {type: 'mo-content', key: 'border', value: `${width} solid ${color}`};
    MenuObject.patchStyles(this.props.isMultiSelect ? this.props.$elements : this.props.$element, patch);
    MenuObject.fixPriceBorder(this.props.$element);

    this.props.updateElementAttribute('borderWidth', val);
  }

  updateBorderRadius(ev) {
    const val = ev.target.value;

    const patch = {type: 'mo-content', key: 'border-radius', value: `${val / 10 + 'em'}`};
    MenuObject.patchStyles(this.props.isMultiSelect ? this.props.$elements : this.props.$element, patch);

    this.props.updateElementAttribute('borderRadius', val);
  }

  updateBackgroundOpacity(ev) {
    const opacity = ev.target ? ev.target.value / 100 : ev;

    const bg = this.props.backgroundColor;
    if (bg) {
      const $element = this.props.$element;
      let styles = MenuObject.getStyles($element);

      let colorData = $element.attr('data-color') ? JSON.parse($element.attr('data-color')) :
                  {mode: 'solid', colors: [styles['mo-content'].background, '#000']};
      colorData = Renderer.addAlphaToColorData(colorData, opacity);
      
      $element.attr('data-color', JSON.stringify(colorData));
      let css = util.getCssFromColorData(JSON.stringify(colorData));

      const patch = {
        type: 'mo-content',
        key: 'background',
        value: css
      };
      MenuObject.patchStyles(this.props.isMultiSelect ? this.props.$elements : this.props.$element, patch);
    }
    this.props.updateElementAttribute('backgroundColorOpacity', (opacity * 100).toFixed(0));
  }

  ungroup() {
    Renderer.ungroup(this.props.$element)
  }

  render(props, state) {
    const isMONameEdit = props.MOEditMode === 'name-notes' && $('.menu-object.select .mo-name.selected').length > 0;
    const isMONotesEdit = props.MOEditMode === 'name-notes' && $('.menu-object.select .mo-notes.selected').length > 0;
    const isMOEntireEdit = !isMONameEdit && !isMONotesEdit;

    return (
      <div className="context-bar">
        <ul>
          {props.isMobileVersion &&
          <li>
            <a className={'mobile-tool-widget'} onClick={this.remove.bind(this)}>
              <DeleteOutlined />
              <span>Delete</span>
            </a>
          </li>}

          {isMOEntireEdit &&
          <li>
            <MenuObjectBorderWidget
              $element={this.props.$element}
              opacity={this.props.backgroundColorOpacity}
              width={this.props.borderWidth}
              color={props.borderColor}
              bgColor={props.backgroundColor}
              value={props.borderRadius}
              withNoBorder={true}
              withClearButton={true}
              openColorPicker={this.openColorPicker.bind(this)}
              onOpacityUpdate={this.updateBackgroundOpacity.bind(this)}
              onWidthUpdate={this.updateBorderWidth.bind(this)}
              onUpdate={this.updateBorderRadius.bind(this)}
              
            />
          </li>}
          {isMONameEdit &&
          <li>
            <MONameBorderWidget
              $element={this.props.$element}
              moNameBackgroundOpacity={this.props.moNameBackgroundOpacity}
              moNameBackgroundColor={this.props.moNameBackgroundColor}
              moNameLineWidth={this.props.moNameLineWidth}
              moNameLineColor={this.props.moNameLineColor}
              moNameBorderWidth={this.props.moNameBorderWidth}
              moNameBorderColor={this.props.moNameBorderColor}
              moNameBackgroundRadius={this.props.moNameBackgroundRadius}
              openColorPicker={this.openColorPicker.bind(this)}
            />
          </li>}
          {isMONotesEdit &&
          <li>
            <MONotesBorderWidget
              $element={this.props.$element}
              moNotesLineWidth={this.props.moNotesLineWidth}
              moNotesLineColor={this.props.moNotesLineColor}
              openColorPicker={this.openColorPicker.bind(this)}
            />
          </li>}
          {(props.isAdmin || props.isDesigner) && !isMONotesEdit && <span className="separator"></span>}
          {(props.isAdmin || props.isDesigner) && !isMONotesEdit &&
          <li>
            <ResizeTextWidget
              width={props.width}
              unit={props.designUnit || 'in'}
              $element={props.$element}
              $elements={props.$elements}
              isMultiSelect={props.isMultiSelect}
              updateElementAttribute={props.updateElementAttribute}
            />
          </li>}
        </ul>

        {!props.isLocked &&
        <ul className="secondary">
          <li className={!props.isInGroup ? 'hidden' : ''}>
            <a className="icn rwd-icon ungroup-btn" onClick={this.ungroup.bind(this)}>
              <span>Ungroup</span>
            </a>
          </li>

          {props.multiselect && <GroupBarListItem {...props} />}
          {canDisplayAlign(props.$element) && <li>
            <PositionTools/>
          </li>}

          {!props.isMobileVersion && <span className="separator"></span>}
          {/*<li>
            <HyperlinkWidget $element={props.$element} href={props.href} isHyperlink={props.isHyperlink} updateElementAttribute={props.updateElementAttribute} hasPdfPermission={props.hasPdfPermission} setActiveMember={props.setActiveMember} />
          </li>*/}
          
          <li>
            <a className={`${!props.isMobileVersion ? 'icn rwd-icon hint--bottom' : 'mobile-tool-widget'}`} data-hint="Duplicate" onClick={this.copy.bind(this)}>
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-copy"}/>
              </svg>
              {props.isMobileVersion && <span>Copy</span>}
            </a>
          </li>

          <li>
            <a className={`${!props.isMobileVersion ? 'icn rwd-icon hint--bottom' : 'mobile-tool-widget'}`} data-hint="Lock" onClick={this.toggleLock}>
              <UnlockOutlined />
              {props.isMobileVersion && <span>Lock</span>}
            </a>
          </li>

          {!props.isMobileVersion &&
          <li>
            {props.isInGroup &&
            <div className="dropdown sizes">
              <a className="dropdown-toggle icn rwd-icon hint--bottom" data-hint="Delete">
                <DeleteOutlined />
              </a>
              <div className="dropdown-menu" style="right: 0; width: auto;">
                <ul className="slider-list">
                  <li><a onClick={this.remove.bind(this)}>Delete</a></li>
                  <li><a onClick={this.removeGroup.bind(this)}>Remove Group</a></li>
                </ul>
              </div>
            </div>}

            {!props.isInGroup &&
            <a className="rwd-icon hint--bottom" data-hint="Delete" onClick={this.remove.bind(this)}>
              <DeleteOutlined />
            </a>}
          </li>}
        </ul>}

        {props.isLocked &&
        <ul className="secondary">
          <li>
            <a className={`${!props.isMobileVersion ? 'icn tgl act rwd-icon hint--bottom' : 'act mobile-tool-widget'}`} data-hint="Unlock" onClick={this.toggleLock}>
              <LockOutlined />
              {props.isMobileVersion && <span>Unlock</span>}
            </a>
          </li>
          <li>
            <a className="locked-label rwd-icon hint--bottom" data-hint="Unlock" onClick={this.toggleLock}>Locked</a>
          </li>
        </ul>}
      </div>
    )
  }
}
